export function NoEventsFound() {
  return (
    <p>
      Geen evenementen gevonden - kijk op{" "}
      <a href="https://www.visitzandvoort.nl/uitagenda/" target="_blank" rel="noreferrer">
        Visit Zandvoort
      </a>
    </p>
  );
}
